export const TESTIMONIALS = [
  {
    id: 1,
    message:
      'Deu tudo certo, graças a Deus e à vocês que nos abriram as portas para que esta cirurgia fosse feita. Estava parado há um ano e agora ele pode voltar a trabalhar.',
    procedure: 'Cirurgia de hérnia umbilical',
    name: 'Luana',
    occupation: 'Esposa do paciente',
  },
  {
    id: 2,
    message:
      'Paciente operada, está com os pais! Cirurgião, anestesista e hospital pagos a contento! Viabilizaram uma cirurgia até então impossível. Vida longa para a Dr.Sim!',
    procedure: 'Cirurgia de Adenotonsilectomia',
    name: 'Dr. Leandro',
    occupation: 'Médico Otorrinolaringologista',
  },
  {
    id: 3,
    message:
      'No SUS eu só tinha a possibilidade de realizar cirurgia aberta. A Dr.Sim me deu a oportunidade de operar por vídeo, o que facilitou na minha recuperação.',
    procedure: 'Retirada de vesícula',
    name: 'Débora',
    occupation: 'Paciente',
  },
]
